<template>
  <div class="AccountLogin">
    <div class="login-inner">
      <div class="login-content">
        <div class="login-title">账号密码登录</div>
        <div class="login-title-line"></div>
        <van-form class="login-form" @submit="onSubmit" ref="loginForm">
          <van-field type="text" v-model="user.username" name="username" placeholder="支持中英文、数字，不超过10个字" maxlength="10" class="iconfont icon-jurassic_user login-field" :rules="[
              { required: true, message: '必填', trigger: 'onChange' },
              { pattern: /[\u4e00-\u9fa5a-zA-Z0-9]+$/, message: '账号有误', trigger: 'onChange' },
            ]" />
          <van-field v-model="user.password" :type="showPassword" name="password" placeholder="请输入8位密码，支持英文、数字" maxlength="8" class="iconfont icon-yuechi login-field" :rules="[
              { required: true, message: '必填', trigger: 'onChange' },
              { pattern: /[a-zA-Z0-9]+$/, message: '密码有误', trigger: 'onChange' },
            ]">
            <template #button>
              <span class="iconfont icon-24gl-eyeHide" @click="xianshieye" :class="xianshi && 'liangeye'"></span>
            </template>
          </van-field>
          <div class="login-nc">
            <a href="javascript:;" ref="wangjimima" @click="toPasswordRetrieval">忘记密码</a>
            <a href="javascript:;" @click="toRegister">立即注册</a>
          </div>
          <div class="login-submit">
            <van-button class="login-submit-btn" round block type="info" native-type="submit">
              <span>提</span><span>交</span>
            </van-button>
          </div>
        </van-form>

        <div class="notice">
          <a href="javascript:;" @click="toMobileVerificationCodeLogin">手机验证登录></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import AreaCode from '@/utils/areaCode'
import { encrypt } from '@/utils/security'

export default {
  name: 'AccountLogin',
  props: {},
  data () {
    return {
      showPassword: 'password',
      xianshi: false,
      areacode: AreaCode[0].code,
      user: {
        username: '',
        password: ''
      },
      isShowpassword: false,
      inputType: 'password'
    }
  },
  created () {
    this.redirectUrl = this.$route.query.redirectUrl
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setToastData', 'setActiveName']),
    xianshieye () {
      this.xianshi = !this.xianshi
      if (this.xianshi == true) {
        this.showPassword = 'type'
      } else {
        this.showPassword = 'password'
      }
    },
    onSubmit (formName) {
      // 表单校验成功调用登录接口

      try {
        this.$Api
          .userLogin({
            username: formName.username,
            password: encrypt(formName.password)
          })
          .then((res, status, message) => {
            if (status == 441) this.$toast(message)
            if (status == '0') this.$toast('登陆成功')
            this.$emit('LoginSuccess', true)
            localStorage.setItem('userInfo', JSON.stringify(''))
            localStorage.setItem('userInfo', JSON.stringify(res))
            // 再次请求用户信息，看是否登录
            setTimeout(() => {
              this.$Api.userGet({}, { noToast: true }).then(data => {
                if (!data) localStorage.setItem('userInfo', '')
                // 是否为注册页面登录
                if (this.$route.path == '/reportDetails') {
                  this.setActiveName(true)
                  // this.$router.go(0)
                } else {
                  // 先跳转到首页
                  this.$router.push('/')
                }
              }).catch(() => {
                localStorage.setItem('userInfo', '')
              })
            }, 500)
          })
      } catch (error) {
        console.log(error)
      }
    },
    toMobileVerificationCodeLogin () {
      this.$emit(
        'toMobileVerificationCodeLogin',
        'MobileVerificationCodeLogin'
      )
    },
    toPasswordRetrieval () {
      this.$emit('toPasswordRetrieval', 'PasswordRetrieval')
    },
    toRegister () {
      this.$router.push('/register')
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.login-inner {
  box-shadow: 0 1.06vw 4.1vw 0 rgb(0 0 0 / 15%);
  border-radius: 8px;
  background: #fafafa;
}
.login-content {
  position: relative;
  background-color: #fff;
  padding: 8.333vw 4.63vw 5.556vw;
  text-align: center;
}
.login-title {
  width: 100%;
  text-align: center;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  font-size: 5.3333vw;
  height: 6.9vw;
}
.login-title-line {
  display: inline-block;
  width: 7vw;
  border-bottom: 1vw solid #0852c8;
}
.login-form {
  margin: 13.333vw 0 8vw 0;
  .van-field {
    margin-bottom: 10.6vw;
    overflow: visible;
    position: relative;
    ::v-deep .van-cell {
      line-height: 0px;
    }
    ::v-deep .van-cell__value {
      position: initial;
    }
    ::v-deep .van-field__error-message {
      position: absolute;
      left: 16px;
      bottom: -5vw;
    }
    ::v-deep .van-field__button {
      height: 24px;
    }
  }
}
.login-nc {
  display: flex;
  justify-content: space-between;
  font-size: 4.2vw;
  padding: 0 16px;
  margin-bottom: 5.2vw;
  a {
    color: #002fa7;
    font-size: 4.26vw;
  }
}
.login-submit {
  height: 10.6667vw;
  display: flex;
  justify-content: center;
  .login-submit-btn {
    height: 10.6667vw;
    font-weight: bold;
    color: #ffffff;
    font-size: 4.26vw;
    line-height: 10.6667vw;
    background: #002fa7;
    span {
      margin: 0 6px;
    }
  }
}
.login-item {
  margin-bottom: 6.019vw;
  position: relative;
  .msg-tips {
    color: red;
    font-size: 2.778vw;
    position: absolute;
    left: 0;
    width: 100%;
    bottom: -4.167vw;
  }
  input {
    width: 100%;
    font-size: 2.778vw;
    appearance: none;
    outline: none;
    box-sizing: border-box;
    border: none;
    border-radius: 0;
    border-bottom: 0.0125rem solid#013995;
    margin-bottom: 1.778vw;
    padding-left: 5vw;
  }
}
.item1 span,
.item2 span {
  position: absolute;
  top: 1vw;
  left: 0;
}
.item2 i {
  position: absolute;
  top: 0;
  right: 0;
}
.notice {
  color: #757575;
  font-size: 2.963vw;
  text-align: center;
  line-height: 1.4;
  margin-top: 8.148vw;
  a {
    text-decoration: none;
    color: #013995;
  }
}
.login-btn {
  button {
    font-size: 3.889vw;
    color: #fff;
    font-weight: bold;
    appearance: none;
    outline: none;
    border: none;
    height: 8.796vw;
    width: 100%;
    border-radius: 4.444vw;
    background: linear-gradient(139deg, #2e76f3, #3f55c2);
    &.disabled {
      background: linear-gradient(139deg, #a7a7a7, #c5c5c5);
    }
  }
}

.bottomLine {
  border: 0.0125rem solid black;
}
.active {
  color: #00ee08;
}
.login-inner {
  background-color: #ffffff;
  border-radius: 0.926vw;
  padding: 0 7.13vw;
  .login-inner-title {
    font-size: 4.074vw;
    color: #333330;
    line-height: 1.4;
    padding: 4.63vw 0 1.852vw;
    text-align: center;
    border-bottom: 0.278vw solid #006df1;
    margin-bottom: 3.241vw;
  }
  .login-nav {
    background-color: #d3e6ff;
    height: 8.704vw;
    border-radius: 0.278vw;
    display: flex;
    span {
      font-size: 3.426vw;
      font-weight: bold;
      color: #006df1;
      flex: 1;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      &.active {
        color: #fff;
        background-color: #006df1;
      }
    }
  }
  .empty-wrapper {
    height: 73.889vw;
    .empty-inner {
      span {
        margin-top: 13.889vw;
        font-size: 0;
        width: 52.963vw;
        height: 10.741vw;
        line-height: 10.741vw;
        background-color: #f5faff;
        &::before {
          content: "敬请期待";
          font-size: 4.074vw;
          color: #80b9ff;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
